import React from 'react';
import styled from 'styled-components';
import BaseAnimatedCircle from './animated-circle';
import BaseCarIcon from './car-icon';

const Wrapper = styled.div`
  width: 100px;
  height: 100px;
  display: grid;
  grid-template: 1fr / 1fr;
  place-items: center;

  & > * {
    grid-area: 1 / 1;
  }
`;

const CarIcon = styled(BaseCarIcon)`
  width: 22%;
`;

const AnimatedCircle = styled(BaseAnimatedCircle)`
  width: 70%;
`;

const LoadingIcon = () => {
  return (
    <Wrapper>
      <CarIcon />
      <AnimatedCircle />
    </Wrapper>
  );
};

export default LoadingIcon;
